var map = {
	"./death_knight/blood.png": 527,
	"./death_knight/frost.png": 528,
	"./death_knight/unholy.png": 529,
	"./demon_hunter/havoc.png": 258,
	"./demon_hunter/vengeance.png": 530,
	"./druid/balance.png": 531,
	"./druid/feral.png": 532,
	"./druid/guardian.png": 533,
	"./druid/restoration.png": 534,
	"./evoker/devastation.png": 535,
	"./evoker/preservation.png": 536,
	"./hunter/beast_mastery.png": 537,
	"./hunter/marksmanship.png": 538,
	"./hunter/survival.png": 539,
	"./mage/arcane.png": 540,
	"./mage/fire.png": 541,
	"./mage/frost.png": 542,
	"./monk/brewmaster.png": 543,
	"./monk/mistweaver.png": 544,
	"./monk/windwalker.png": 545,
	"./paladin/holy.png": 546,
	"./paladin/protection.png": 547,
	"./paladin/retribution.png": 548,
	"./priest/discipline.png": 549,
	"./priest/holy.png": 550,
	"./priest/shadow.png": 551,
	"./rogue/assassination.png": 552,
	"./rogue/outlaw.png": 553,
	"./rogue/subtlety.png": 554,
	"./shaman/elemental.png": 555,
	"./shaman/enhancement.png": 556,
	"./shaman/restoration.png": 557,
	"./warlock/affliction.png": 558,
	"./warlock/demonology.png": 559,
	"./warlock/destruction.png": 560,
	"./warrior/arms.png": 561,
	"./warrior/fury.png": 562,
	"./warrior/protection.png": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1100;